import { EnrichmentDescription } from "./enrichmentDescription";

export class EnrichmentPage {

    public isPage: boolean = false;
    public id: any = 0;
    public isSelected: boolean = false;
    public level: Number = 0;
    public children: Array<EnrichmentPage> = new Array<EnrichmentPage>();
    public title: String = "";
    public type: String = "";
    public description: EnrichmentDescription = new EnrichmentDescription();
    public contentDocId: String = "";

}



// WEBPACK FOOTER //
// ./src/app/shared/models/enrichmentPage.ts